import script from "./ProjectMainTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectMainTab.vue?vue&type=script&setup=true&lang=js"

import "./ProjectMainTab.vue?vue&type=style&index=0&id=2e62df78&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e62df78"]])

export default __exports__